import axios from 'axios'

export default {
  fetchAddresses(params) {
    return axios.get('/api/admin/addresses', { params })
  },
  fetchAddressColumns() {
    return axios.get('/api/admin/addresses/columns')
  },
  updateAddressColumn(name) {
    return axios.post('/api/admin/addresses/columns/update', { name })
  },
  updateAddressColumnOrder(orderedColumns) {
    return axios.post('/api/admin/addresses/columns/update-order', { ordered_columns: orderedColumns })
  },
  downloadAddressTemplate() {
    return axios.get('/api/admin/addresses/template', {
      responseType: 'blob'
    })
  },
  exportAddresses(data) {
    return axios.post('/api/admin/addresses/export', data)
  },
  importAddresses(formData) {
    return axios.post('/api/admin/addresses/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  deleteAddresses(ids) {
    return axios.post('/api/admin/addresses/bulk-delete', { ids })
  }
}